import { useRef } from 'react'
import { useAppSelector } from '@services/store'
import {
	REQUEST_CONFIGS_KEYS,
	REQUEST_TN_DETAILS_STEPS_NAME
} from '@services/constants'
import requestForm from '../../request.form'
import { isResidentialLandPermitGR6_5 } from '../__index.utils'

export const STEP4_5FIELDS = {
	typesOfWorkDiverse: 'typesOfWorkDiverse',
	areaScreen: 'areaScreen',
	areaOutdoorStorage: 'areaOutdoorStorage'
} as const

export function useStep4_5State() {
	const answers = useAppSelector((state) => state.request.configs)
	const { pageAssets } = requestForm()

	const isGR6_5 = isResidentialLandPermitGR6_5(answers?.whatToDo)

	return {
		// Quel(s) type(s) de travaux souhaitez-vous effectuer?
		typesOfWorkDiverse: {
			name: 'typesOfWorkDiverse',
			label:
				pageAssets?.request_form_residentialRenovationOrRepairPermit_typesOfWork,
			labelKey: 'request_form_residentialRenovationOrRepairPermit_typesOfWork',
			value: answers?.typesOfWorkDiverse?.toString() || '',
			required: isGR6_5,
			ref: useRef<HTMLSelectElement>(null),
			subStep: REQUEST_TN_DETAILS_STEPS_NAME.DETAILS_4
		},
		// Quel est le type d'installation?

		// Superficie
		areaScreen: {
			name: 'areaScreen',
			label: pageAssets?.request_form_surfaceArea_installation,
			labelKey: 'request_form_surfaceArea',
			value: answers?.areaScreen?.toString() || '',
			required: false,
			ref: useRef<HTMLInputElement>(null),
			subStep: REQUEST_TN_DETAILS_STEPS_NAME.DETAILS_4
		},
		areaUnitScreen: {
			name: 'areaUnitScreen',
			label: pageAssets?.request_form_area_unit,
			labelKey: 'request_form_area_unit',
			value:
				answers.areaUnitScreen?.toString() ||
				REQUEST_CONFIGS_KEYS.measurement_unit.meters_unit,
			required: false,
			ref: useRef<HTMLSelectElement>(null),
			subStep: REQUEST_TN_DETAILS_STEPS_NAME.DETAILS_4
		},

		// Superficie
		areaOutdoorStorage: {
			name: 'areaOutdoorStorage',
			label: pageAssets?.request_form_surfaceArea_installation,
			labelKey: 'request_form_surfaceArea',
			value: answers?.areaOutdoorStorage?.toString() || '',
			required: false,
			ref: useRef<HTMLInputElement>(null),
			subStep: REQUEST_TN_DETAILS_STEPS_NAME.DETAILS_4
		},
		// Superficie unit
		areaUnitOutdoorStorage: {
			name: 'areaUnitOutdoorStorage',
			label: pageAssets?.request_form_area_unit,
			labelKey: 'request_form_area_unit',
			value:
				answers.areaUnitOutdoorStorage?.toString() ||
				REQUEST_CONFIGS_KEYS.measurement_unit.meters_unit,
			required: false,
			ref: useRef<HTMLSelectElement>(null),
			subStep: REQUEST_TN_DETAILS_STEPS_NAME.DETAILS_4
		}
	}
}
